const root = () => '/';
const callback = () => '/callback';
const login = (fromPath?: string) => `/login${fromPath ? '?referer=' + fromPath : ''}`;
const logout = () => '/logout';
const authLanding = () => '/auth';
const templateManagement = () => '/templatemanagement';
const reporting = () => '/reporting';
const geoFuse = () => '/geofuse';
const users = () => '/users';
const usersCreate = () => '/users/create';
const usersEdit = () => '/users/edit/:editId';
const organizations = () => '/organizations';
const submissions = () => `/submissions`;
const submissionDetail = (id?: string) => `/submission/${id || ':id'}`;
const submissionForm = (id?: string) => `/submission/form/${id || ':id'}/`;
const submissionFormDetails = (id?: string) => `/submission/form/${id || ':id'}/details`;
const overview = (id?: string) => `${submissionDetail(id)}/overview`;
const notes = (id?: string) => `${submissionDetail(id)}/notes`;
const financial = (id?: string) => `${submissionDetail(id)}/financial`;
const clearing = (id?: string) => `${submissionDetail(id)}/clearing`;
const historicalLocations = (id?: string) => `${submissionDetail(id)}/historicallocations`;
const SOV = (id?: string) => `${submissionDetail(id)}/sov`;
const lossSummary = (id?: string) => `${submissionDetail(id)}/losssummary`;
const sovMap = (id?: string) => `${submissionDetail(id)}/sovmap`;
const uwReview = (id?: string) => `${submissionDetail(id)}/review`;
const agentDashboard = () => '/agentdashboard';
const lumenDashboard = () => '/lumendashboard';
const submissionAgentDashboard = (id?: string) => `${submissionDetail(id)}/agentDashboard`;
const quotes = (id?: string) => `${submissionDetail(id)}/quotes/prepare`;
const quotesView = (id?: string) => `${submissionDetail(id)}/quotes/view`;
const quoteReview = (id?: string) => `${submissionDetail(id)}/quotes/review`;
const endorsememtReview = (id?: string) => `${submissionDetail(id)}/endorsement/review`;
const bindRequest = (id?: string) => `${submissionDetail(id)}/quotes/bind`;
const issuance = (id?: string) => `${submissionDetail(id)}/issuance`;
const location = (id?: string, locationId?: number) =>
    `${submissionDetail(id)}/location/${locationId || ':locationId'}`;
const referrals = (id?: string) => `${submissionDetail(id)}/referrals`;

const programSetup = (productType?: string, entity?: string) => {
    const base = '/program-setup';
    if (productType && entity) return `${base}/${productType}/${entity}`;
    if (productType) return `${base}/${productType}`;
    return base;
};

const carriers = () => '/carriers';

export const PROGRAM_SETUP_ENTITIES = {
    SUBSCRIPTIONS: 'subscriptions',
    PROGRAM_SUBSCRIPTIONS: 'program-subscriptions',
    CARRIER_TREATY_YEARS: 'carrier-treaty-years',
    CARRIERS: 'carriers',
    LUMEN_PROGRAM_YEARS: 'lumen-program-years',
};

export const PROGRAM_SETUP_PRODUCT_TYPES = {
    COMMERCIAL_PROPERTY: 'commercial-property',
    GENERAL_LIABILITY: 'general-liability',
    BUILDERS_RISK: 'builders-risk',
};

export const PRODUCT_TYPE_SLUG_TO_CODE: Record<string, string> = {
    'commercial-property': 'COMMERCIAL_PROPERTY',
    'general-liability': 'GENERAL_LIABILITY',
    'builders-risk': 'BUILDERS_RISK',
};

export default {
    root,
    callback,
    login,
    logout,
    authLanding,
    templateManagement,
    reporting,
    users,
    usersCreate,
    usersEdit,
    organizations,
    submissions,
    submissionDetail,
    submissionForm,
    submissionFormDetails,
    overview,
    notes,
    financial,
    clearing,
    historicalLocations,
    SOV,
    lossSummary,
    sovMap,
    uwReview,
    agentDashboard,
    lumenDashboard,
    submissionAgentDashboard,
    quotes,
    quotesView,
    quoteReview,
    bindRequest,
    issuance,
    location,
    endorsememtReview,
    referrals,
    geoFuse,
    programSetup,
    carriers,
};
